import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import ArrowDown from '../svg/arrow-down';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

class SurveyBody extends React.Component {
  static propTypes = {
    callback: PropTypes.func.isRequired,
    scrollCalendar: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      showMoreText: false,
      questions: [
        {
          title: proxyCounterpart('QUESTION_1_TITLE'),
          question: proxyCounterpart('QUESTION_1_QUESTION'),
          answer: false,
          name: 'question_1'
        },
        {
          title: proxyCounterpart('QUESTION_2_TITLE'),
          question: proxyCounterpart('QUESTION_2_QUESTION'),
          answer: false,
          name: 'question_2'
        },
        {
          title: proxyCounterpart('QUESTION_3_TITLE'),
          question: proxyCounterpart('QUESTION_3_QUESTION'),
          answer: false,
          name: 'question_3'
        },
        {
          title: proxyCounterpart('QUESTION_3-1_TITLE'),
          question: proxyCounterpart('QUESTION_3-1_QUESTION'),
          answer: false,
          name: 'question_3.1'
        },
        {
          title: proxyCounterpart('QUESTION_3-2_TITLE'),
          question: proxyCounterpart('QUESTION_3-2_QUESTION'),
          answer: false,
          name: 'question_3.2'
        },
        {
          title: proxyCounterpart('QUESTION_3-3_TITLE'),
          question: proxyCounterpart('QUESTION_3-3_QUESTION'),
          answer: false,
          name: 'question_3.3'
        },
        {
          title: proxyCounterpart('QUESTION_3-4_TITLE'),
          question: proxyCounterpart('QUESTION_3-4_QUESTION'),
          answer: false,
          name: 'question_3.4'
        },
        {
          title: proxyCounterpart('OTHER_RISK_COMMENT'),
          name: 'question_3.comment'
        },
        {
          title: proxyCounterpart('QUESTION_4_TITLE'),
          question: proxyCounterpart('QUESTION_4_QUESTION'),
          answer: false,
          name: 'question_4'
        }
      ],
      comment: '',
      questionComment: ''
    };
  }

  onChangeQuestionAnswer = (index, answer) => {
    const newQuestions = this.state.questions;

    newQuestions[index].answer = answer;

    this.setState({
      questions: newQuestions
    });
  }

  callbackSurveyAnswers = () => {
    const answers = [];
    let status = true;

    this.state.questions.forEach((question) => {
      if (question.name !== 'question_3.comment') {
        const answer = question.answer ? 'Ja' : 'Nej';
        answers.push(JSON.stringify({ answer: answer, question: question.question }));
        if (question.answer === true) {
          status = false;
        }
      }
    });

    answers.push(JSON.stringify({ risk_information_comment: this.state.questionComment }));
    answers.push(JSON.stringify({ optional_comment: this.state.comment }));

    this.props.callback(answers.toString(), status);
  }

  renderQuestionRow = (question, index, isSubQuestion) => {
    const setTrue = () => this.onChangeQuestionAnswer(index, true);
    const setFalse = () => this.onChangeQuestionAnswer(index, false);

    const containerWrapperClass = 'surveyContainerWrapper gray fixed-height flex-row';

    return (
      <div
        key={question.name}
        className={isSubQuestion ? containerWrapperClass + ' margin-left-20' : containerWrapperClass}
      >
        <div className='surveyContainer large'>
          <div className='surveySubtitle'>
            {question.title}
          </div>
          <div className='surveyBodyText'>
            {question.question}
          </div>
        </div>
        <div className='surveyContainer small flex-row justify-end'>
          <input id={question.name + '-alt-1'}
            type='radio'
            name={question.name}
            value
            checked={question.answer}
            onChange={setTrue} />
          <label className='surveyAnswer' htmlFor={question.name + '-alt-1'}>
            <span className='no-margin'></span>
            <Translate className='surveyAnswerText' content='YES' />
          </label>

          <input id={question.name + '-alt-2'} type='radio' name={question.name} value={false}
            checked={!question.answer}
            onChange={setFalse} />
          <label className='surveyAnswer' htmlFor={question.name + '-alt-2'}>
            <span className='no-margin'></span>
            <Translate className='surveyAnswerText' content='NO' />
          </label>
        </div>
      </div>
    );
  }

  renderQuestionComment = (question) => {
    return (
      <div
        key={question.name}
        className='surveyContainerWrapper gray flex-column margin-left-20'
      >
        <div className='surveySubtitle'>
          {question.title}
        </div>
        <textarea className='no-margin'
          name='survey-question-comment'
          value={this.state.questionComment}
          onChange={this.setQuestionComment}
        />
      </div>
    );
  }

  renderQuestions = () => {
    let questions = [];

    this.state.questions.forEach((question, index) => {
      const question3 = this.state.questions[2];
      const isSubQuestion = question.name.includes('.');

      if (!isSubQuestion || question3.answer) {
        let surveyQuestion = this.renderQuestionRow(question, index, isSubQuestion);
        if (question.name === 'question_3.comment') {
          surveyQuestion = this.renderQuestionComment(question);
        }

        questions.push(surveyQuestion);
      }
    });

    return (
      <div className='surveyColumnContainer'>
        {questions}
        <div className='surveyContainerWrapper gray flex-column'>
          <Translate className='surveySubtitle' content='OPTIONAL_COMMENT' />
          <textarea className='no-margin'
            name='survey-comment'
            value={this.state.comment}
            onChange={this.setComment}
          />
        </div>
      </div>
    );
  }

  setComment = (event) => {
    this.setState({
      comment: event.target.value
    });
  }

  setQuestionComment = (event) => {
    this.setState({
      questionComment: event.target.value
    });
  }

  showMoreText = () => {
    this.setState({
      showMoreText: !this.state.showMoreText
    });
  }

  renderShowMoreText = () => {
    if (this.state.showMoreText) {
      return (
        <div className='surveyBodyText pre-wrap'>
          {proxyCounterpart('MORE_INFORMATION_TEXT')}
        </div>
      );
    }
  }

  render = () => {
    return (
      <div className='surveyColumnContainer'>
        <Translate className='surveyTitle' content='EXCEEDING_WORKING_HOURS_TITLE' />
        <Translate className='surveyText' content='SURVEY_INFORMATION_TEXT' />
        <div
          className='surveyContainerWrapper blue flex-column'
          onClick={this.showMoreText}
        >
          <div className='surveyContainerWrapperRow'>
            <div className='surveyContainer large flex-row center'>
              <Translate className='surveySubtitle' content='MORE_INFORMATION' />
            </div>
            <div className='surveyContainer small center flex-row justify-end'>
              <ArrowDown />
            </div>
          </div>
          {this.renderShowMoreText()}
        </div>
        <div className='surveyContainerWrapper blue flex-row'>
          <div className='surveyContainer small flex-row center'>
            <Translate className='surveySubtitle' content='ENTERED_WRONG_HOURS' />
          </div>
          <div className='surveyContainer small flex-row center justify-end'>
            <button
              key='changeHours'
              className='btn px-30 outlined blue'
              onClick={this.props.scrollCalendar}
            >
              <Translate content='CHANGE_WORKING_HOURS' />
            </button>
          </div>
        </div>
        <Translate className='surveySubtitle' content='QUESTIONS_WORKING_CONDITIONS' />
        {this.renderQuestions()}
        <div className="btn-wrapper">
          <button
            key='send'
            className='btn'
            onClick={this.callbackSurveyAnswers}
          >
            <Translate content='SEND_SURVEY_RESPONSE' />
          </button>
        </div>
      </div>
    );
  }
}

export default SurveyBody;



/** WEBPACK FOOTER **
 ** ./src/components/exceeded-working-hours-survey-modal/survey-body.js
 **/